/* eslint-disable no-console */
import SiteModal from './site-modal';

export default class SitePopup extends SiteModal {
  open() {
    // If any type of modal is open, do not continue
    const isModalOpen = document.querySelectorAll('.modal.modal-visible').length > 0;
    if (isModalOpen) {
      return;
    }
    super.open();
  }
}
/* eslint-enable no-console */
